import EducationInfo from './EducationInfo';

export default EducationInfo;
